import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';
import FauxSelect from '../Common/FauxSelect';

const ExamType = observer(class ExamType extends React.Component {
  constructor() {
    super();
    this.selectExam = this.selectExam.bind(this);
  }

  componentWillMount() {
    const _this = this;

    const callback = () => {
      _this.props.routing.push('exams/add');
    }

    this.props.store.ExamStore.resetLMSExams();
    this.props.store.ExamStore.getLMSExams(callback);
  }

  selectExam(e, props, i) {
    this.props.store.ExamStore.selectLMSExam(i);
  }

  render() {
    const { translation } = this.props;
    const { ExamStore, SessionStore } = this.props.store;
    const { lmsExams } = ExamStore;
    let actions = [];

    if(!SessionStore.loading) {
      for(let i = 0; i < lmsExams.length; i++) {
        // Create option object
        const action = {
          title: lmsExams[i].title
        }

        actions.push(action);
      }

      return (
        <main tabIndex="0" id="main-content" className="page wrap">
          <div className="panel panel--medium panel--medium-alt">
            <h1 className="meta">{translation.page_title}</h1>

            <div className="panel__sections">
              <section className="panel__half">
                <h2 className="panel__title">
                  <icons.iconImport />
                  {translation.import.heading}
                </h2>

                <p>{translation.import.body}</p>
                <div className='note'>
                  <p>{translation.import.not_showing.description}</p>
                  <ul>
                    {translation.import.not_showing.reasons.map(reason => (
                      <li>{reason}</li>
                    ))}
                  </ul>
                </div>

                <FauxSelect
                  default={translation.new.select}
                  options={actions}
                  onClick={this.selectExam}
                  noTooltip={true}
                />

                <Link className="btn" to="exams/add">{translation.import.button}</Link>
              </section>

              <section className="panel__half">
                <h2 className="panel__title">
                  <icons.iconPaper />
                  {translation.new.heading}
                </h2>

                <p>{translation.new.body}</p>

                <Link className="btn" to="exams/add">{translation.new.button}</Link>
              </section>
            </div>
          </div>
        </main>
      )
    }

    return null;
  }
})

export default translate('ExamType')(ExamType);



// WEBPACK FOOTER //
// ./src/app/components/ExamEdit/ExamType.js